// @ts-nocheck
function getTimestampOrUndefined(value) {
    if (!value) {
        return undefined;
    }
    const timestamp = new Date(value).getTime();
    return Number.isFinite(timestamp) ? timestamp : undefined;
}
export function normalizeWorkflowDefinition(payload, existing = {}) {
    const previous = existing;
    const steps = payload.steps ?? previous.steps ?? [];
    return {
        ...previous,
        workflow_id: payload.workflow_id,
        name: payload.name ?? previous.name,
        description: payload.description ?? previous.description,
        tenant_id: payload.tenant_id ?? previous.tenant_id,
        user_id: payload.created_by_user_id ?? previous.user_id,
        version: payload.version ?? previous.version,
        steps,
        etl_config: { steps },
        tags: payload.tags ?? previous.tags ?? [],
        is_active: payload.is_active ?? previous.is_active ?? true,
        created_at: payload.created_at ?? previous.created_at,
        updated_at: payload.updated_at ?? previous.updated_at,
    };
}
export function normalizeExecutionSummary(payload, tenantId) {
    const createdAt = payload.created_at ?? undefined;
    const startedAt = payload.started_at ?? undefined;
    const completedAt = payload.completed_at ?? payload.finished_at ?? undefined;
    const startedAtMs = getTimestampOrUndefined(startedAt);
    const completedAtMs = getTimestampOrUndefined(completedAt);
    const durationMs = startedAtMs !== undefined && completedAtMs !== undefined
        ? Math.max(0, completedAtMs - startedAtMs)
        : undefined;
    const status = payload.status === 'succeeded' ? 'completed' : payload.status;
    const stepResults = (payload.step_results ?? []).map((step) => ({
        ...step,
        status: step.status === 'succeeded' ? 'completed' : step.status,
    }));
    return {
        execution_id: payload.workflow_execution_id ?? payload.execution_id,
        workflow_id: payload.workflow_id,
        workflow_version: payload.workflow_version,
        tenant_id: tenantId,
        user_id: payload.triggered_by_user_id ?? payload.user_id ?? '-',
        status,
        created_at: createdAt,
        started_at: startedAt,
        completed_at: completedAt,
        duration_ms: durationMs,
        step_results: stepResults,
        final_result: payload.final_result,
        final_result_step_id: payload.step_id,
        error_message: payload.error_message ?? payload.error_summary,
        metadata: payload.metadata ?? {},
    };
}
export function hydrateScheduleCard(schedule, workflowName, detail) {
    const recentExecutions = detail?.recent_executions ?? [];
    const successCount = recentExecutions.filter((item) => item.status === 'succeeded' || item.status === 'completed').length;
    const failureCount = recentExecutions.filter((item) => item.status === 'failed').length;
    let lastStatus;
    if (detail?.last_execution_summary?.status === 'succeeded' || detail?.last_execution_summary?.status === 'completed') {
        lastStatus = 'success';
    }
    else if (detail?.last_execution_summary?.status === 'failed') {
        lastStatus = 'failure';
    }
    else if (detail?.last_execution_summary?.status === 'cancelled') {
        lastStatus = 'cancelled';
    }
    return {
        schedule_id: schedule.schedule_id,
        tenant_id: schedule.tenant_id,
        workflow_id: schedule.workflow_id,
        workflow_name: workflowName,
        name: schedule.name || workflowName,
        description: schedule.description || '',
        cron_expression: schedule.trigger?.cron || '',
        timezone: schedule.trigger?.timezone || 'UTC',
        enabled: schedule.enabled,
        created_at: schedule.created_at,
        created_by: schedule.created_by_user_id,
        last_run_at: detail?.last_execution_summary?.started_at,
        next_run_at: schedule.next_run_at,
        run_count: recentExecutions.length,
        success_count: successCount,
        failure_count: failureCount,
        last_status: lastStatus,
    };
}
